<template>
    <div>
        <template v-if="wholesaler === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Active Shops ({{active_count}})</h1>
                <router-link to="/addShop" class="btn btn-primary float-right active"> Add New Shop</router-link>
                <router-link to="/bulkAddShops" class="btn btn-primary float-right mr-1">Add Bulk Shops</router-link>
                <div class="searching float-right mr-2">
                    <input id="search_active" type="text" placeholder="Search" class="form-control search" name="" />
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
				<div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
					<table id="shopsTable" class="table">
                        <thead>
                            <tr>
                                <td>Sr.</td>
                                <td>Shop Name</td>
                                <td>Shop Owner Name</td>
                                <td>Phone</td>
                                <td>Address</td>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
				</div>
				<!-- <div class="tab-pane fade" id="inactive" role="tabpanel" aria-labelledby="inactive-tab">
					<table id="shopsTable" class="table">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Payment Engine</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th class="text-center">Action</th>
                            </tr>
                        </thead>
                    </table>
				</div> -->
				
			</div>
        </template>
        <template v-else-if="wholesaler === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="wholesaler === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                wholesaler: null,
                shopsTable : null,
                dtActive : null,
                active_count : 0,
            };
        },
        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('wholesaler').then(result => {
                this.wholesaler = result.wholesaler;
            }).then(result => {
                if(this.wholesaler == true){
                    this.activeShop();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            activeShop(){
                var that = this;
                this.shopsTable = $('#shopsTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listShops",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records"
                    },
                    deferRender: true,
                    columns: [
                        
                        {render: function(data,type,full,row){
                            var rowNo = row.row+1+(row.settings.oAjaxData.start);
                            return rowNo;
                        }},
                        {data: 'shop'},
                        {data: 'name'},
                        {data: 'phone'},
                        {data: 'address'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editShop/'+full['shop_id'];
                            // return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"><i class="fas fa-pencil-alt"></i></a> | <a href="javascript:void(0);" onclick="VueComponents.shopComponent.methods.deleteShop('+full['id']+')" class="action edit"><i class="fas fa-trash"></i></a>';
                            return '<a href="javascript:void(0);" onclick="VueComponents.shopComponent.methods.deleteShop('+full['id']+')" class="action edit"><i class="fas fa-trash"></i></a>';
                        }}
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 5 ]
                    }],
                    "initComplete": (settings, json) => { 
                        this.active_count = json.recordsTotal; 
                        this.$Progress.finish();
                    },

                });
                $('#search_active').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        that.shopsTable.search(this.value).draw();
                    }
                });
            },
           deleteShop(id){
               var that = this;
               gThat.$Progress.start();
               swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this shop!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get("/api/softDeleteShop/"+id)
                        .then(res => {
                            if(res.status == 200){
                                if(res.data.status == 200){
                                    gThat.$Progress.finish();
                                    gThat.shopsTable.ajax.reload( json => {
                                        gThat.active_count = json.recordsTotal;
                                    }, false);
                                    gThat.showAlertBox('success','Shop deleted successfully.');
                                }else{
                                    gThat.showToastBox('error','System is not responding! Please try again later.');
                                }
                            }else{
                                gThat.$Progress.fail();
                                gThat.showAlertBox('error','System is not responding! Please try again later.');
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            gThat.$Progress.fail();
                            gThat.showAlertBox('error','System is not responding! Please try again later.');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        gThat.$Progress.finish();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                });
                
           },
        },
    }
</script>
